<template>
  <div 
    id="viewReserved"
    ref="viewReserved"
    >
    <div class="border-0 card mb-0 mt-2 rounded ui-index">
      <div class="border-bottom header-elements-sm-inline pr-0">
        <ul
          class="nav nav-tabs nav-tabs-bottom border-bottom-0 pl-3 custom-pb-tab-product"
        >
          <li
            v-for="(tabs, index) in tabLabel"
            :key="`tabs-${index}`"
            class="nav-item"
          >
            <a
              href="#bottom-divided-tab1"
              @click="tabShow(tabs.name)"
              data-toggle="tab"
              :class="['nav-link', activeTab == tabs.name ? 'active' : '']"
              data-test="tab-order"
            >
              <i :class="['mr-1', tabs.icon]" />
              {{ tabs.text }}
              <span :class="[tabs.badge, 'ml-1']">
                {{ tabs.count | formatNumberNotZero }}
              </span>
            </a>
          </li>
        </ul>
      </div>
      <div class="">
        <div class="card-body p-0">
          <div class="p-3 pt-0">
            <div
              class="toobar-search d-flex flex-row align-items-center justify-content-between"
            >
              <div class="input-group w-40 mr-2">
                <input
                  v-model="filters.search"
                  type="text"
                  name="search"
                  :placeholder="$t('Search...')"
                  class="border-right-0 form-control pl-2 px-0"
                  @keydown.enter.prevent="handlerClickSearch(filters.search)"
                  data-test="input-search"
                />
                <span class="input-group-append">
                  <button
                    v-if="isSearched"
                    class="
                          btn btn-outline-normal
                          border-left-0
                          btn-search
                          btn-order-search
                        "
                    type="button"
                    @click="clearSearch"
                    data-test="btn-clear-search"
                  >
                    <i class="fas fa-times-circle" />
                  </button>
                  <button
                    v-else
                    @click="handlerClickSearch(filters.search)"
                    type="button"
                    class="btn btn-outline-normal border-left-0 btn-search"
                    data-test="btn-search"
                  >
                    <i class="far fa-search" />
                  </button>
                </span>
              </div>
              <div class="align-items-center d-flex mr-2 w-50">
                <span class="mr-2 text-center text-nowrap">
                  {{ $t('Filters') }}
                </span>
                <Select2
                  v-model="filters.salesChannelId"
                  :options="channelOptions"
                  :settings="settingsChannel"
                  style="width: 100%"
                  @change="onValueChange"
                  data-test="select-sales-channel"
                />
              </div>
              <!-- <div class="dataTables_length ml-auto">
                <per-page @per-page="setPerPage" />
              </div> -->
            </div>
            <!-- <div class="col-6 mt-2 pr-2">
                <div class="dataTables_length ml-auto">
                  <per-page @per-page="setPerPage" />
                </div>
              </div> -->
          </div>
          <div id="tab_reserve">
            <div
              id="table-reserve"
              class="tab-content border-top"
              :class="[
                'table-responsive mt-0 main-scroll data-nowrap table-order',
                reserveLoading
              ]"
              data-test="table-reserve"
            >
              <vuetable
                :no-data-template="$t('No Data Available')"
                class="dataTable thead-bg-fafafa table-hover"
                ref="vuetable"
                :data-manager="dataManagerReserve"
                :api-mode="false"
                :append-params="queryParamsReserve"
                :fields="fields"
                :css="{ sortableIcon: 'grey sort icon' }"
                @vuetable:pagination-data="onPaginationDataReserve"
                @vuetable:loaded="vuetableLoadedReserve"
                @vuetable:loading="vuetableLoadingReserve"
                data-path="data"
                pagination-path=""
                @vuetable:initialized="onInitialized"
                :detail-row-class="'product-link-tr'" 
              >
                <div slot="ch" slot-scope="props">
                  <ChannelsLogoComponent
                    :product-id="props.rowData.id"
                    :channels-name="props.rowData.sales_channel"
                    :channels-image-url="props.rowData.sales_channel_logo"
                    data-test="data-sales-channel-logo"
                  />
                </div>

                <div slot="order_number" slot-scope="props">
                  <a
                    class="text-dark"
                    :href="'/app/orders/' + props.rowData.id"
                    target="_blank"
                    data-test="data-order-number"
                  >
                    <span class="btn-link pointer mr-1 "
                      >{{ props.rowData.order_number }}
                    </span>
                  </a>
                </div>
                <div slot="fullname" slot-scope="props">
                  <span
                    v-if="props.rowData.fullname"
                    class="btn-link pointer fullname-column"
                    @click="openTabCustomer(props.rowData.customer_id)"
                    data-test="data-fullname"
                  >
                    {{ props.rowData.fullname }}
                  </span>
                  <span v-else class="fullname-column">
                    -
                  </span>
                </div>
              </vuetable>
            </div>
            <div class="datatable-footer px-2">
              <vuetable-pagination-info
                class="dataTables_info"
                ref="paginationInfo"
                :no-data-template="$t('No relevant data')"
                :info-template="
                  $t('Displaying {from} to {to} of {total} items')
                "
                data-test="pagination-info"
              />

              <div class="dataTables_paginate paging_simple_numbers mb-0">
                <vuetable-pagination
                  ref="pagination"
                  pagination-path="pagination"
                  @vuetable-pagination:change-page="onChangePageReserve"
                  data-test="table-pagination"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/services/endpoint/tenant.service";
import moment from "moment";
import Vuetable from "vuetable-2";
import numeral from "numeral";
import { convertTimezone } from "@/common/tenancy/convertTimezone";
import ProductImageComponent from "@/components/tenancy/center/ProductImageComponent.vue";
import FieldsDef from "./assets/FieldsItemReserve";
import PerPage from "./assets/PerPage.vue";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "@/plugins/vuetable-2/VuetablePaginationInfo.vue";
import ChannelsLogoComponent from "@/components/tenancy/center/ChannelsLogoComponent.vue";
import ChannelsNameComponent from "@/components/tenancy/center/ChannelsNameComponent.vue";
import Select2 from 'v-select2-component'

export default {
  name: "viewReserved",
  components: {
    Vuetable,
    ProductImageComponent,
    FieldsDef,
    PerPage,
    VuetablePagination,
    VuetablePaginationInfo,
    ChannelsLogoComponent,
    ChannelsNameComponent,
    Select2
  },
  props: {
    productsId: {
      type: [Object, Array],
      default: undefined
    }
  },
  data() {
    return {
      popperOption: {
        placement: "top-start",
        modifiers: {
          hide: { enabled: false },
          preventOverflow: { enabled: false } // responsive in class table-responsive
        }
      },
      dataFooterFields: [],
      fields: FieldsDef,
      vuetableFields: false,
      isSearched: false,
      perPage: 10,
      filters: {
        search: "",
        salesChannelId: "",
        limit: 10,
        page: 1
      },
      reserveLoading: "loading",
      filtersReserve: {
        search: "",
        sales_channel_id: "",
        limit: 10,
        page: 1,
        product_ids: []
      },
      queryParamsReserve: {
        search: "",
        limit: 10,
        page: 1,
        product_ids: [],
        sales_channel_id: "",
      },
      tabLabel: [
        {
          name: 'orders',
          text: this.$t("Orders"),
          icon: "fas fa-cart",
          badge: "badge bg-primary-700",
          count:0,
        },
      ],
      checkTab: 0,
      activeTab: 'orders',
      searchChannel: null,
      channelOptions: [],
      settingsChannel:{
        allowClear: true,
        minimumResultsForSearch: Infinity,
        dropdownCssClass: 'reserve-layout',
        placeholder: this.$t("channel"),
        escapeMarkup: function (markup) {
          return markup;
        },
        templateResult: this.templateResultChannel,
        templateSelection: this.templateSelectionChannel
      }
    };
  },
  async mounted() {
    this.$nextTick(() => {
      const iconElementLeft = document.querySelector('#view_modal_update_salable .angle.double.left.icon');
      const iconElementReft = document.querySelector('#view_modal_update_salable .angle.double.right.icon');
      if (iconElementLeft) {
        const btnNav = iconElementLeft.closest('.btn-nav.icon.item');

        if (btnNav) {
          btnNav.style.display = 'none';
        }
      }
      if (iconElementReft) {
        const btnNav = iconElementReft.closest('.btn-nav.icon.item');

        if (btnNav) {
          btnNav.style.display = 'none';
        }
      }
    });
  },
  methods: {
    onValueChange(val) {
       this.reserveLoading = "loading";
       this.filtersReserve.sales_channel_id = val;
      this.getReserveList(this.filtersReserve);
    },
    setPerPage(perPage) {
      this.reserveLoading = "loading";
      this.filtersReserve.limit = perPage;
      this.getReserveList(1);
    },
    onPaginationDataReserve(tablePagination) {
      this.$refs.paginationInfo.setPaginationData(tablePagination);
      this.$refs.pagination.setPaginationData(tablePagination);
    },
    onChangePageReserve(page) {
      this.filtersReserve.page = page;
      // this.changePage(page); /
      this.$refs.vuetable.changePage(page);
      // this.getReserveList(this.filtersReserve, page);
    },
    openTabCustomer(id) {
      let routeData = this.$router.resolve({
        name: "t.a.customer",
        query: {
          customerId: id,
          activeTab: "card-tab1"
        }
      });
      setTimeout(() => {
        window.open(routeData.href, "_blank").focus();
      });
    },
    handlerClickSearch(search) {
      this.reserveLoading = "loading";
      this.filtersReserve.search = search;
      this.isSearched = this.filtersReserve.search != "" ? true : false;
      this.getReserveList(this.filtersReserve);
    },
    clearSearch() {
      this.$nextTick(() => {
        this.isSearched = false;
        this.filters.search = "";
        this.queryParamsReserve.search = this.filters.search;
        this.filtersReserve.search = this.filters.search;
        this.getReserveList(this.filtersReserve);
      });
    },
    async getReserveList(filters, page = null) {
      this.reserveLoading = "loading";
      this.filtersReserve.product_ids = this.productsId;
      if (page == 1) {
        this.filtersReserve.page = page;
        this.$refs.vuetable.currentPage = page;
      } else {
        this.filtersReserve.page = this.$refs.vuetable.currentPage;
      }
      Object.keys(filters).map(key => {
        this.queryParamsReserve[key] = filters[key];
      });

      let queryString = "";
      if (this.queryParamsReserve) {
        queryString += "?" + $.param(this.queryParamsReserve);
      }
      try {
        let response = await Api.ProductV2.getReservedList(queryString);

        this.channelOptions = response.data.filter.sales_channel.map(item => ({
            id: item.id,
            text: item.name,
            logo: item.logo
        }));
        const data = this.$storeIndex.mutations.vueTableFormatJson(response);
        this.$refs.vuetable.setData(data);

        const tabOrders = this.tabLabel.find(item => item.name === 'orders');
        if (tabOrders) {
          tabOrders.count = response.data.meta.total; // เปลี่ยนเป็นค่าที่คุณต้องการ เช่น 5
        }

      } catch (error) {
        console.log(error);
      }
    },
    onInitialized(fields) {
      this.vuetableFields = fields.filter(field => field.togglable);
    },
    vuetableLoadedReserve() {
      this.reserveLoading = "";
    },
    vuetableLoadingReserve() {
      this.reserveLoading = "loading";
    },
    dataManagerReserve() {
      this.getReserveList(this.filtersReserve);
    },
    tabShow(publish) {

      this.checkTab = publish;

    },
    templateResultChannel(data) {
      let option = "";
      if (data.id == "") {
        option = this.$t("channel");
      } else {
        const imageChannel = data.logo ? data.logo : this.$storeIndex.getImageSrc("channel/none");

        option = `
          <div class="item-bottom row ml-0">
            <img class="rounded pointer mr-2" width="20" height="20" src="${imageChannel}" alt="">
            <span class="mr-2">${data.text}</span>
          </div>
        `;
      }
      return option;
    },
    templateSelectionChannel: function(data) {
      if (data.id == "") {
        return this.$t("channel");
      }

      const imageChannel = data.logo ? data.logo : this.$storeIndex.getImageSrc("channel/none");

      return `
        <div class="item-bottom row ml-0">
          <img class="rounded pointer mr-2 mt-1" width="20" height="20" src="${imageChannel}" alt="">
          <span class="mr-2">${data.text}</span>
        </div>
      `;
    },
  },
  computed: {
  },
  watch: {},
  filters: {
    formatNumber: function(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberNotZero: function(value) {
      return numeral(value).format("0,0");
    },
  }
};

</script>

<style scoped>
.select2-container {
  z-index: 9999 !important;
}
.select2-dropdown {
  z-index: 9999 !important;
}
.fullname-column {
  max-width: 100px;  /* กำหนดความกว้างสูงสุด */
  white-space: normal; /* ให้ข้อความขึ้นบรรทัดใหม่ */
  word-wrap: break-word; /* ให้ตัดคำถ้ายาวเกิน */
}
</style>




// WEBPACK FOOTER //
// src/components/tenancy/admin/stock/Reserved.vue